export const MEDIA_PREVIEW_MAX_SIZE = { width: 440, height: 560 };
export const ARTICLE_PREVIEW_MAX_SIZE = { width: 440, height: 324 };
export const LINK_PREVIEW_MAX_SIZE = { width: 406, height: 256 };
export const MINIATURE_PREVIEW_MAX_SIZE = { width: 40, height: 40 };

export const HIGHLIGHTED_TEXT_ATTRIBUTE_NAME = 'data-highlighted-text';
